module.exports = __webpack_public_path__ + "img/tu1.6757c97d.png";